import React from 'react'

import { DeliveryCalculator } from '/react4xp/parts/delivery/calculator-delivery-time'

export default (props) => <DeliveryCalculator {...props} />
